import { Component, h } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './index.module.css';
import { KosmodPage, kosmodSite, useFrontendCore, useFrontendServices } from "@kosmod/core";
import { Page } from "@kosmod/graphics-2d";
import { AccountDescription } from "../../defs";

export type FooterProps = {
  account: null | AccountDescription
};

const FooterLink: Component<{ page: KosmodPage }> = ({ page, children }) => {
  const { site } = useFrontendServices();

  return h(html.a, { href: page.path, onClick(e) {
    e.preventDefault();
    site.navigate({ path: page.path })
  } }, children);
};

export const Footer: Component<FooterProps> = ({ account }) => {
  return h('footer', { className: classes.footer }, [
    h(html.nav, { className: classes.footerNav }, [
      h(html.ol, { className: classes.navSection }, [
        h(FooterLink, { page: kosmodSite.home }, 'Home'),
        h(FooterLink, { page: kosmodSite.features }, 'Features'),
        h(FooterLink, { page: kosmodSite.development }, 'Development'),
        h(FooterLink, { page: kosmodSite.market }, 'Market'),
        h(FooterLink, { page: kosmodSite.plus }, 'Plus'),
      ].map(n => h(html.li, {}, n))),
      h(html.ol, { className: classes.navSection }, [
        h(FooterLink, { page: kosmodSite.privacyPolicy }, 'Privacy Policy'),
        h(FooterLink, { page: kosmodSite.termsOfUse }, 'Terms of Use'),
      ].map(n => h(html.li, {}, n))),
      h(html.ol, { className: classes.navSection }, [
        h(FooterLink, { page: kosmodSite.login }, 'Log In'),
        h(FooterLink, { page: kosmodSite.signUp }, 'Sign Up'),
        h(FooterLink, { page: kosmodSite.demo }, 'Open Demo'),
      ].map(n => h(html.li, {}, n))),
      !!account && h(html.ol, { className: classes.navSection }, [
        h(FooterLink, { page: kosmodSite.games }, 'My Games'),
      ].map(n => h(html.li, {}, n))),
    ]),
    h(html.div, { className: classes.copyInfo }, [
      'kosmod studios ©'
    ])
  ])
}